<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Produs</label>
              <el-select
                v-model="selectedProduct"
                @change="handleProductSelect"
                placeholder="Caută produsul..."
                filterable
                remote
                :remote-method="fetchProducts"
                :loading="loadingProducts"
              >
                <el-option
                  v-for="product in searchProdResults"
                  :key="product._id"
                  :label="product.name"
                  :value="product._id"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>Date</label>
              <el-date-picker
                type="daterange"
                v-model="searchDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :name="['date_from', 'date_to']"
              ></el-date-picker>
            </div>
          </div>

         </div>
         <div class="right-buttons">
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="data-table">
                <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;">
                    <el-table-column :label="$t('gestiune.stockDate')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.date">
                          {{ formatDateTime(scope.row.date) }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column prop="document_id" :label="$t('gestiune.stockDocumentId')"></el-table-column>
                    <el-table-column prop="document_type" :label="$t('gestiune.stockDocumentType')"></el-table-column>
                    <el-table-column prop="intrare" :label="$t('gestiune.stockIntrare')"></el-table-column>
                    <el-table-column prop="iesire" :label="$t('gestiune.stockIesire')"></el-table-column>
                    <el-table-column prop="stoc_final" :label="$t('gestiune.stockStocFinal')"></el-table-column>
                    <el-table-column :label="$t('gestiune.stockPret')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.pret">
                          {{ (scope.row.pret).toFixed(2) }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('gestiune.stockValoareStoc')">
                      <template slot-scope="scope">
                        <template v-if="scope.row.valoare_stoc">
                          {{ (scope.row.valoare_stoc).toFixed(2) }}
                        </template>
                      </template>
                    </el-table-column>
                    <el-table-column prop="observatii" :label="$t('gestiune.stockObservatii')"></el-table-column>
                </el-table>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      loadingTimeout: null,
      searchProdResults: [],
      selectedVatNumber: null,
      selectedProduct: null,
      loadingProducts: false,
      tableData: [],
      searchDate: false,
      filter: {
        series: ''
      },
      selectedGestiune: null,
      selectedLocation: null
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    searchDate (newGestiune) {
      this.searchTerm = null
      this.tableData = []
      if (this.selectedLocation && this.selectedGestiune && this.selectedProduct) {
        this.getData()
      }
    },
    selectedLocation (newLocation) {
      this.selectedGestiune = null
      this.tableData = []
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code
    },
    selectedGestiune (newGestiune) {
      this.selectedProduct = null
      this.searchProdResults = []
      this.tableData = []
    },
    groupedLocations (newVal) {
      this.firstLoad()
    },
    gestiuneOptions (newVal) {
      this.firstLoad()
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
    },
    formatDate (row, column, cellValue) {
      if (!cellValue) return ''
      return new Date(cellValue).toLocaleDateString()
    },
    async getData (date = null) {
      const externalCompanyId = this.companyID

      clearTimeout(this.loadingTimeout)
      this.loadingTimeout = setTimeout(() => {
        this.loading = true
      }, 200)
      this.tableData = []

      if (!externalCompanyId) {
        return
      }
      if (!this.selectedGestiune) {
        return
      }
      if (!this.selectedProduct) {
        return
      }

      let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stock_history?externalCompanyId=${externalCompanyId}`
      if (date) {
        url += `&date=${date}`
      }
      if (this.selectedGestiune) {
        url += `&gestiune=${this.selectedGestiune}`
      }
      if (this.selectedProduct) {
        url += `&product_id=${this.selectedProduct}`
      }
      if (this.selectedLocation) {
        url += `&externalLocationId=${this.selectedLocation.true_id}`
      }
      if (this.searchDate && this.searchDate[0] && this.searchDate[0]) {
        url += `&startDate=${this.searchDate[0]}`
        url += `&endDate=${this.searchDate[1]}`
      }

      try {
        const response = await fetch(url)
        const data = await response.json()

        clearTimeout(this.loadingTimeout)
        this.loading = false

        if (Array.isArray(data.history)) {
          this.tableData = data.history
        } else {
          console.error('Invalid data format:', data)
        }
      } catch (error) {
        console.error('Error fetching invoices:', error)
      }
    },
    handleProductSelect (product) {
      this.getData()
    },
    async fetchProducts (searchTerm) {
      if (!searchTerm || searchTerm.length < 2) {
        this.searchProdResults = []
        return
      }

      this.loadingProducts = true

      try {
        const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?vatNumber=${this.selectedVatNumber}&name=${encodeURIComponent(searchTerm)}&externalCompanyId=${this.companyID}`)
        const data = await response.json()

        if (Array.isArray(data.products)) {
          this.searchProdResults = [
            ...data.products
          ]
        } else {
          this.searchProdResults = [
          ]
        }
      } catch (error) {
        console.error('Error fetching products:', error)
        this.searchProdResults = [
        ]
      } finally {
        this.loadingProducts = false
      }
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/StockHistoryReport.vue